import { findInMessagesByName, isNode } from '../helpers';

export const hasMainEntities = (node) =>
  !!(node.data.entities && node.data.entities.length);

export const getNameFromEntityType = (node) =>
  node.data.entities && node.data.entities[0] && node.data.entities[0].type;

export const markMainEntity = (tree) => {
  const menuMainObject = tree.data.messages.find(
    (msg) =>
      msg.name === getNameFromEntityType(tree).toLowerCase() ||
      msg.name === getNameFromEntityType(tree)
  );
  menuMainObject && (menuMainObject.isMainObject = true);
  return menuMainObject;
};

export const markMainEntitiesVisitor = (node) => {
  /*
    if node has entities:
    1. extract the entityName from the entity type
    2. find the relevant message by the entity name
    3. mark the message with isMainEntity = true
  */
  if (isNode(node) && hasMainEntities(node)) {
    const entityName = getNameFromEntityType(node);
    const msg = findInMessagesByName(node, entityName);
    msg && (msg.isMainEntity = true);
  }
};
